export function toDateString(datetime) {
  return datetime.toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'America/New_York' });
}

export function toTimeString(datetime) {
  return datetime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true , timeZone: 'America/New_York' });
}